<template>
	<div class="">
		<div class="w-full bg-white h-[74px]" v-if="isFinish">
			<examHeader :title="title"></examHeader>
			<div class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px] h-[78vh]  mr-[10px] flex flex-col ">
					<div
						class=" relative flex-1 overflow-y-auto shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[22px] box-border">
						<div class="mb-[42px] relative z-10">
							<div class="mb-[20px] flex  ">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo.cancel_collect:langInfo.click_collect"
									placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{(data_current_page - 1 ) * 20 + currentTopic +1}}. <div
										v-html="currentTopicInfo.content" class="whitespace-pre-wrap"></div>
								</div>
							</div>
							<div class=" pl-[68px] box-border relative z-10 text-[#101010]"
								v-if="currentTopicInfo.question_type==1">
								<div v-for="(item,index) in optionsList" class="flex items-center mb-[10px] ">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px]">{{item.key}}.</label><label class="cursor-pointer"
										v-html="item.value"></label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==3">
								<!-- 判断题传 1对0错 -->
								<div class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer=='1'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['right']}}</label>
								</div>
								<div class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer=='0'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['wrong']}}</label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==5">
								<div v-html="currentTopicInfo.analysis"></div>

							</div>
						</div>
						<div class="bg-[#F5F5F5] p-[22px] box-border mb-[18px] relative" style="z-index: 0;">
							<div class="flex items-center mb-[10px]">
								<img src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
								<label
									class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_tip}}</label>
							</div>
							<div v-if="currentTopicInfo.question_type==1 ||currentTopicInfo.question_type==3"
								class="text-[16px] text-[#101010] font-semibold mb-[10px]">
								<label class="min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
								<label v-if="currentTopicInfo.question_type==1">{{currentTopicInfo.answer}}</label>
								<label
									v-else-if="currentTopicInfo.question_type==3">{{currentTopicInfo.answer=='1'?'对':'错'}}</label>
							</div>
							<div class=" text-[16px]  text-[#101010] flex ">
								<label class="font-semibold min-w-[80px] flex justify-between">
									{{langInfo.study_paper_answer_tip}}：</label>
								<div v-html="currentTopicInfo.analysis"
									class="flex-1 text-[#101010] whitespace-pre-wrap">
								</div>
							</div>
						</div>

						<div @click="askVisible=true"
							class="relative z-10 cursor-pointer flex items-center text-[#D86D21] text-[16px]">
							<img src="@/static/image/icon42.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
							{{langInfo.study_paper_answer_submit}}
						</div>
						<!-- 水印 -->
						<div class=" absolute w-full h-full top-0 left-0 bg-repeat"
							:style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}">
						</div>
						<!-- 水印 -->
					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()"
							:class="((data_current_page - 1 ) * 20 + currentTopic +1)==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()"
							:class="((data_current_page - 1 ) * 20 + currentTopic +1)==data_log_all?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1 h-[78vh] flex flex-col">
					<div
						class="flex-1 flex flex-col mb-[10px]  shadow-01 pb-[20px] box-border rounded-[6px]  bg-white overflow-hidden">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class=" flex flex-wrap  overflow-y-auto py-[20px] px-[13px] box-border ">
							<div @click="selectTopic(item,index)"
								class="topicItem relative mb-[10px] bg-[#68C340] cursor-pointer  flex items-center justify-center text-white  text-center box-border"
								v-for="(item,index) in topicList" :key="index">
								<img v-if="item.is_user_collection==1" :src="collectActive"
									class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]" alt=""
									srcset="" />
								<!-- <label class="cursor-pointer"> {{index + 1 }}</label> -->
								<label class="cursor-pointer">{{(data_current_page - 1 ) * 20 + index +1}}</label>
							</div>

						</div>
						<div class="  flex items-center justify-center mt-[14px]">
							<div @click="prePaperCard()" :class="data_current_page==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
								class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
								{{langInfo.study_paper_answer_pre}}
							</div>
							<div @click="nextPaperCard()"
								:class="total_page==data_current_page?'bg-[#8FC3FF]':'bg-[#2979FF]'"
								class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
								{{langInfo.study_paper_answer_next}}
							</div>
						</div>

					</div>
					<div @click="backStudyCenter()"
						class="shadow-01 rounded-[6px] cursor-pointer h-[56px]  bg-[#E6F2FF] text-[#3894FF] flex items-center justify-center">
						{{langInfo.study_paper_answer_back}}
					</div>
				</div>
			</div>
		</div>

		<!-- 提问/纠错 -->
		<questionCorrection :askVisible="askVisible" :order_item_id="orderId" :id="currentTopicInfo.id"
			:title="langInfo.study_question_tip" :course_subject_id="currentTopicInfo.course_subject_id"
			@close="closeVisible">
		</questionCorrection>
		<!-- 提问/纠错 -->

	</div>
</template>

<script>
	import examHeader from '@/components/examHeader.vue'
	import questionCorrection from '@/components/questionCorrection.vue'
	export default {
		components: {
			questionCorrection,
			examHeader
		},
		data() {
			return {
				isFinish: false,

				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + '@' + this.$common
					.currentTime() + '@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,

				title: '',

				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),


				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				optionsList: [],
				currentTopicInfo: {
					id: '',
					content: '',
					is_user_collection: 0,

				},
				currentTopic: 0,

				topicList: [],
				askVisible: false, //疑问纠错


				id: '',
				orderId: '',
				mode: '', //mode 1章节练习   2收藏练习  
				langInfo: {},


				data_log_all: 0,
				data_log_limit: 0,
				data_log_page: 1,
				data_current_page: 1,
				total_page: 1,


				order: 1, //1正序  2倒序

				currentUserRecord: {
					id: '',
					user_answer: ''
				},

			}
		},
		mounted() {
			this.orderId = this.$route.query.orderId;
			this.id = this.$route.query.id;
			this.mode = this.$route.query.mode;
			this.isFinish = false
			this.getQuestionLog()
			// this.getQuestionInfo()
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}



		},
		destroyed() {
			console.log("销毁")
			console.log("销毁===========");

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getQuestionLog() {
				var type = "memorize"
				if (this.mode == 2) {
					type = "collect_sele"
				}
				this.$api.getQuestionLog({
					small_id: this.id,
					type: type,
					order_item_id: this.orderId,

				}).then((res) => {
					console.log(res.data);

					this.data_log_all = res.data.data_log_all
					this.data_log_limit = res.data.data_log_limit
					this.data_log_page = res.data.data_log_page

					this.data_current_page = res.data.data_log_page


					this.total_page = Math.ceil(this.data_log_all / 20)

					this.currentTopic = this.data_log_limit

					this.getQuestionInfo()

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getQuestionInfo() {

				var type = "memorize"
				if (this.mode == 2) {
					type = "collect_sele"
				}

				this.$api.getQuestionPaper({
					small_id: this.id,
					type: type,
					order_item_id: this.orderId,
					page: this.data_log_page
				}).then((res) => {

					this.isFinish = true

					//mode 1章节练习   2收藏练习
					if (this.mode == 1) {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_exercise_read
					} else if (this.mode == 2) {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_collect_view
					}

					document.title = this.title;

					// is_user_collection=是否收藏0否1是
					res.data.data.forEach((item, index) => {
						item.options.forEach((itm, ind) => {
							this.$set(itm, 'isSelect', false)
						})
					})

					this.topicList = res.data.data;


					this.data_current_page = parseInt(res.data.input_page)

					if (this.order == 2) {
						this.currentTopic = this.topicList.length - 1
					} else {
						if (parseInt(res.data.input_page) != res.data.data_log_page) {
							this.currentTopic = 0
						} else {
							this.currentTopic = parseInt(res.data.data_log_limit)
						}
					}

					this.getCurrentInfo()

				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			prePaperCard() {
				this.order = 1
				this.changePre()
			},
			nextPaperCard() {
				this.order = 1
				this.changeNext()
			},

			getCurrentInfo() {

				this.currentUserRecord = {
					id: '',
					user_answer: ''
				}

				let userrecord = this.topicList[this.currentTopic].userrecord
				this.currentUserRecord = userrecord

				this.currentTopicInfo = this.topicList[this.currentTopic]
				this.currentTopicInfo.options.forEach((item, index) => {
					if (this.currentTopicInfo.answer == item.key) {
						item.isSelect = true
					}
				})

				this.optionsList = this.currentTopicInfo.options


				this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)

				this.get_user_log()
			},
			decodeHtml(html) {
				if (!html) return ''

				const textarea = document.createElement('textarea')
				textarea.innerHTML = html

				return textarea.value
			},
			get_user_log() {

				//mode 1章节练习   2收藏练习  
				var type = 3
				if (this.mode == 2) {
					type = 5
				}
				this.$api.user_log({
					action: 'question',
					type: type,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})

			},

			// 上一页
			preTopic() {
				if (this.currentTopic == 0) {
					this.order = 2
					this.changePre()
					return
				}
				this.currentTopic--;
				this.order = 2

				this.getCurrentInfo()
			},
			changePre() {
				this.data_log_page = this.data_current_page
				if (this.data_log_page == 1) {
					return
				}
				this.data_log_page--;
				this.getQuestionInfo()
			},
			nextTopic() {
				console.log('this.currentTopic===' + this.currentTopic);
				console.log('this.this.topicList.length===' + this.topicList.length);
				if ((this.currentTopic + 1) == this.topicList.length) {
					this.order = 1
					this.changeNext()
					return
				}
				this.order = 1
				this.currentTopic++
				this.getCurrentInfo()
			},

			changeNext() {
				this.data_log_page = this.data_current_page
				if (this.total_page == this.data_log_page) {
					return
				}
				this.data_log_page++;
				this.getQuestionInfo()
			},
			selectTopic(item, index) {
				this.order = 1
				this.currentTopic = index
				localStorage.setItem('currentTopic', this.currentTopic)
				this.getCurrentInfo()
			},
			// 返回学习中心
			backStudyCenter() {
				window.close()
			},
			// 收藏
			collectClick() {
				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}
				this.topicList[this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection

				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			closeVisible() {
				this.askVisible = false
			}
		}
	}
</script>

<style scoped>
	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;

	}

	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);

	}

	/deep/p img {
		width: 100% !important;
	}
</style>